module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/babel-runtime/regenerator/index.js
// module id = 516
// module chunks = 20